$(document).ready(function () {
  // Search Bar Script
  $('.searchBoxInput input').attr('placeholder', 'Search')
  $('.searchBoxInput input').val('')
  $('#mobileSearchInput').attr('placeholder', 'Search')
  $('#mobileSearchInput').val('')

// Phone header

  // Navigation blur
  $('<div class="blur-bg"></div>').appendTo('#mainNavigation .items')

  // General Message
  $('.generalmessage').prependTo('header');

  // Feature LineUp Customized
  // -------------OVERLAY FOR LINEUPS
  let nmbrSlides = 1
  $('.featureLineupModule .featureLineupContainer').each(function () {
    $(this).find(".subContainer .featureLineupImage").prepend('<div class="overlay-lineup"></div>')
    // $(this).find(".overlay-lineup").addClass(`obg${nmbrSlides++}`)
  })

  setTimeout(() => {
    //Words "days until" after countdays
    $(".countdownDays").children('').text('days until ')
  }, 500)


  // Get updataes customization
  $('.seo-signup .emailInputField input').attr('placeholder', 'Enter Email');
  $('.seo-signup .emailInputField input').val('')

  $('.seo-signup .emailInputSubmit a').text('sign up')

  $('.seo-signup .emailInputField, .seo-signup .emailInputSubmit').wrapAll('<div class="signup-container"></div>')
  $('<h3 class="signUp-title">Get updates</h3>').prependTo('.emailSignup')
});

$(window).load(function () {

  // Weather Script
  setInterval(function () {
    var str = $('#weatherBugDescription').text();
    var weatherBugSet = $('#weatherBugWidget').hasClass('weatherBugSet');
    if (weatherBugSet || str == '') return
    $('#weatherBugWidget').addClass('weatherBugSet');
    var findSpace = str.lastIndexOf(' ');
    var stringLength = str.length;
    var res = str.substring(findSpace, stringLength);
    var start = str.substring(0, findSpace);
    $('#weatherBugDescription').html('<span class="weatherDescriptive">' + start + '</span>' + res);
    $('#weatherBugWidget').css('visibility', 'visible');
  }, 12);
});


